import React from 'react';

// Shown when a Firestore read is denied by security rules (permission-denied)
// rather than genuinely empty. Keeps rules denials from rendering as fake "no
// data" states (Review 3 Batch B, #27). Self-contained inline styles so it
// drops cleanly into any surface (Bootstrap, portal, teacher-dashboard CSS).
// Copy follows core.md voice: warm, never blame, no raw system/error strings.
function AccessNotice({ what = 'this', className = '' }) {
	return (
		<div
			className={`cyv-access-notice ${className}`.trim()}
			role="status"
			style={{
				display: 'flex',
				gap: '0.85rem',
				alignItems: 'flex-start',
				maxWidth: '32rem',
				margin: '1.25rem auto',
				padding: '1rem 1.25rem',
				border: '1px solid rgba(0,0,0,0.08)',
				borderRadius: '0.75rem',
				background: 'rgba(0,0,0,0.02)',
			}}>
			<i
				className="fa-sharp fa-solid fa-lock"
				aria-hidden="true"
				style={{ color: '#8a6d3b', marginTop: '0.15rem', fontSize: '1.1rem' }}
			/>
			<div>
				<div style={{ fontWeight: 600 }}>
					You don't have access to {what}.
				</div>
				<div
					style={{
						marginTop: '0.2rem',
						fontSize: '0.9rem',
						color: 'var(--text-muted, #6b7280)',
					}}>
					An owner can grant this from Staff Access.
				</div>
			</div>
		</div>
	);
}

export default AccessNotice;
